<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :scroll="{ x: 1530 }"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #areaList="{ record }">
      <div>
        {{
          record.areaList
            .map(i => {
              return `${i.countryName}${
                i.provinceName ? `/${i.provinceName}` : ''
              }`
            })
            .join(';')
        }}
      </div>
    </template>
    <template #enable="{ record }">
      <div class="ellipsis">
        <a-switch
          :unCheckedValue="0"
          :checkedValue="1"
          v-model:checked="record.enable"
          @click="changeEnable(record)"
        />
      </div>
    </template>
    <template #themeSort="{ record }">
      <div class="">
        {{ record.themeTypeSort.join('>') }}
      </div>
    </template>
    <template #deal="{ record }">
      <div class="tal">
        <a-button
          :disabled="record.disableEdit"
          type="link"
          @click="changeVisible(true, record, 'edit')"
          >编辑</a-button
        >
        <a-popconfirm
          title="确定删除?"
          ok-text="确定"
          cancel-text="取消"
          trigger="click"
          @confirm="() => deleteRow(record)"
          @cancel="cancel"
        >
          <a-button type="link">删除</a-button>
        </a-popconfirm>
      </div>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: '国家-省州',
        slots: { customRender: 'areaList' },
        key: 'areaList',
        align: 'center'
      },
      {
        title: '主题顺序',
        key: 'themeSort',
        slots: { customRender: 'themeSort' },
        align: 'center',
        width: 240
      },
      {
        title: '是否启用',
        key: 'enable',
        slots: { customRender: 'enable' },
        align: 'center',
        width: 120
      },

      {
        title: '操作',
        slots: { customRender: 'deal' },
        key: 'deal',
        fixed: 'right',
        width: 200
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style>
.ellipsis {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
